import { useMemo, useRef, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../store/store';
import { useParams } from 'react-router-dom';
import { EXTENDED_INTERVAL_UPDATE_DATA } from '../../../../../constants/common';
import { usePolling } from '../../../../../hooks/usePolling';
import { filterCyclesBySearchQuery } from '../../../../ContractScreensView/utils/filterCyclesBySearchQuery';
import { ILoadActiveCyclesWIthoutScreen } from '../interfaces/ILoadActiveCyclesWIthoutScreen';

export const useLoadActiveCyclesWIthoutScreen = (): ILoadActiveCyclesWIthoutScreen => {
  const [isLoading, setIsLoading] = useState(false);

  const { clientId } = useParams();

  const {
    cycles: {getScreenlessCyclesByLocation },
  } = useAppDispatch();

  const { activeScreenlessCycles, searchCycleQuery } = useAppSelector((state) => state.cycles);

  const cycles = useMemo(() => {
    if (!searchCycleQuery) {
      return activeScreenlessCycles;
    }

    return filterCyclesBySearchQuery(activeScreenlessCycles, searchCycleQuery);
  }, [activeScreenlessCycles, searchCycleQuery]);

  const isChangeLoading = useRef(true);

  const fetchDataHandler = async (locationId: string) => {
    try {
      if (!locationId) {
        return;
      }

      if (isChangeLoading.current) {
        setIsLoading(true);
      }

      await getScreenlessCyclesByLocation(locationId);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isChangeLoading.current = false;
    }
  };

  usePolling(() => fetchDataHandler(clientId), EXTENDED_INTERVAL_UPDATE_DATA, [clientId]);

  return {
    cycles,
    isLoading,
  };
};
